
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/[id]",
      function () {
        return require("private-next-pages/embed/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/[id]"])
      });
    }
  